/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Crystallizer } from "./modelCrystallizer";

class ControllerCrystallizer extends ControllerModel {
    constructor() {
        super("ControllerCrystallizer");

        this.setNewNode = (callback) => {
            let crystallizer = new Crystallizer();
            crystallizer.decorate(callback);

            this.addNode(crystallizer);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let crystallizer = new Crystallizer();
            crystallizer.copyFrom(node);
            crystallizer.decorate(callback);
            this.addNode(crystallizer)
        }

        this.getProperties = async (node) => {
            let n = new Crystallizer();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Crystallizer();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerCrystallizer };